import React from 'react';

const DisclaimerTicker = () => {
    const disclaimerText = "Ratchagan Analysis is an educational platform only. We are NOT SEBI registered investment advisors. Stock market investments are subject to market risks. Past performance does not guarantee future results.";

    return (
        <div className="fixed bottom-0 left-0 right-0 w-full bg-[#00008B] h-8 md:h-10 flex items-center overflow-hidden whitespace-nowrap group z-[60] border-t border-white/10">
            <div className="inline-block animate-marquee group-hover:[animation-play-state:paused] md:[animation-duration:30s] [animation-duration:40s]">
                {[...Array(4)].map((_, i) => (
                    <span key={i} className="inline-flex items-center mx-4">
                        <span className="text-white text-[11px] font-bold tracking-wider uppercase">
                            {disclaimerText}
                        </span>
                        <span className="mx-6 md:mx-8 w-1.5 h-1.5 rounded-full bg-accent" />
                    </span>
                ))}
            </div>
            <div className="inline-block animate-marquee group-hover:[animation-play-state:paused] md:[animation-duration:30s] [animation-duration:40s]" aria-hidden="true">
                {[...Array(4)].map((_, i) => (
                    <span key={i} className="inline-flex items-center mx-4">
                        <span className="text-white text-[11px] font-bold tracking-wider uppercase">
                            {disclaimerText}
                        </span>
                        <span className="mx-6 md:mx-8 w-1.5 h-1.5 rounded-full bg-accent" />
                    </span>
                ))}
            </div>
        </div>
    );
};

export default DisclaimerTicker;
